export default "__VITE_ASSET__Cge6ADEi__"